import { useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { useSettingIsPerfAppSemDiscoverTreatment } from "@faire/retailer-visitor-shared/settings/useSettingPerfAppSemDiscover";
import { useIsLoggedOutDiscoverPage } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useIsLoggedOutDiscoverPage";
import { PHASE_4_DISCOVER_PAGE_IMPROVEMENTS_120224 } from "@faire/web-api--source/indigofair/settings/PHASE_4_DISCOVER_PAGE_IMPROVEMENTS_120224";

export const useSettingDiscoverPageImprovements = () => {
  const isTreatment = useSetting(
    PHASE_4_DISCOVER_PAGE_IMPROVEMENTS_120224,
    false
  );
  const isLoggedOutDiscoverPage = useIsLoggedOutDiscoverPage();
  const isPerfAppSemDiscoverTreatment =
    useSettingIsPerfAppSemDiscoverTreatment();
  return (
    !isPerfAppSemDiscoverTreatment && isTreatment && isLoggedOutDiscoverPage
  );
};
